import { useQuery } from "@tanstack/react-query";
import { getSkillById } from "../../api/apiSkills";

/**
 * Hook لجلب مهارة واحدة
 * @param {number|string} id - Skill ID
 */
export function useGetSkill(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["skill", id],
        queryFn: () => getSkillById(id),
        enabled: !!id,
        retry: false,
    });

    const skill = data?.data || null;

    return { isLoading, error, skill, refetch };
}